import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicyHero from "./sections/PrivacyPolicyHero";
import PrivacyPolicy from "./sections/PrivacyPolicy";
import RelatedLinksEstimateForm from "./sections/RelatedLinksEstimateForm";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PrivacyPolicyHero />
      <PrivacyPolicy />
      <RelatedLinksEstimateForm />
      <Footer />
    </div>;
}